import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import BookSearch from './components/BookSearch';
import BookDetail from './components/BookDetail';
import SavedBooks from './components/SavedBooks';
import MySummaries from './components/MySummaries';
import MyQuestions from './components/MyQuestions';
import Settings from './components/Settings';
import DeleteAccount from './components/DeleteAccount';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import SubscribeSuccess from './components/SubscribeSuccess';
import UpgradeSuccess from './components/UpgradeSuccess';
import Admin from './components/Admin';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
};

function App() {
  // Update document title based on URL
  useEffect(() => {
    const url = window.location.href.toLowerCase();
    const hasAISparkNotes = url.includes('aisparknotes');
    const appName = hasAISparkNotes ? 'AISparkNotes' : 'BookSummary';
    document.title = `${appName} - AI Book Summaries`;
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <div className="main-content">
            <Routes>
              <Route path="/index.html" element={<Navigate to="/" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/subscribe-success" element={<SubscribeSuccess />} />
              <Route path="/upgrade-success" element={<PrivateRoute><UpgradeSuccess /></PrivateRoute>} />
              <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/search" element={<PrivateRoute><BookSearch /></PrivateRoute>} />
              <Route path="/book/:id" element={<PrivateRoute><BookDetail /></PrivateRoute>} />
              <Route path="/saved" element={<PrivateRoute><SavedBooks /></PrivateRoute>} />
              <Route path="/summaries" element={<PrivateRoute><MySummaries /></PrivateRoute>} />
              <Route path="/questions" element={<PrivateRoute><MyQuestions /></PrivateRoute>} />
              <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
              <Route path="/delete-account" element={<PrivateRoute><DeleteAccount /></PrivateRoute>} />
              <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
